import React from 'react';
var CONTAINER_STYLES = 'absolute right-0 top-100 w-screen';
var DROPDOWN_STYLES = 'flex flex-col flex-grow w-screen sm:w-4/5 md:w-2/5 lg:w-1/5 xl:w-1/6 bg-navBackground text-navContent absolute top-0 right-0 z-20';
export var Dropdown = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: CONTAINER_STYLES },
        React.createElement("nav", { className: DROPDOWN_STYLES }, children)));
};
